module.exports = __webpack_public_path__ + "fonts/dFa5ZfeM_74wlPZtksIFYuUe6HOpW3pwfa0.woff2";